import { CourseFilterDto } from '../../../../api-service/clients';
import { IStartPageTableFilter } from '../../../../components/start-page-table/start-page-table-filter-chooser';

export const courseFilters: IStartPageTableFilter[] = [
  { id: CourseFilterDto.Active, label: 'Aktive hold', description: 'Hold der ikke er afsluttet' },
  { id: CourseFilterDto.All, label: 'Alle hold', description: 'Alle hold i virksomheden' },
  {
    id: CourseFilterDto.WithoutCurrentLessons,
    label: 'Alle hold uden aktuelle lektioner',
    description: 'Hold der ikke har lektioner fra dags dato og frem (aflyste lektioner tæller ikke med)',
  },
  { id: CourseFilterDto.Mine, label: 'Mine hold', description: 'Hold hvor jeg er ansvarlig sagsbehandler eller underviser' },
];
